import { render } from "./FarmOsCreateUUID.vue?vue&type=template&id=02b9add4"
import script from "./FarmOsCreateUUID.vue?vue&type=script&lang=js"
export * from "./FarmOsCreateUUID.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__